(() => {
function initNH(root) {
  if (!root || root.dataset.nhReady) return;
  root.dataset.nhReady = '1';
  const $ = (s, el = root) => el.querySelector(s), $$ = (s, el = root) => [...el.querySelectorAll(s)];
  const moneyFormat = root.dataset.moneyFormat || '$';
  const L = '{' + '{', R = '}' + '}';
  const money = c => {
    const a = moneyFormat.indexOf(L), b = moneyFormat.indexOf(R), n = c / 100;
    if (a < 0 || b < 0) return n.toFixed(2);
    const k = moneyFormat.slice(a + 2, b).trim();
    let v = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (k === 'amount_no_decimals') v = Math.round(n).toLocaleString('en-US');
    if (k === 'amount_with_comma_separator') v = n.toFixed(2).replace('.', ',');
    return moneyFormat.slice(0, a) + v + moneyFormat.slice(b + 2);
  };
  const cartAdd = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js';
  const cartUrl = root.dataset.cartUrl || '/cart';
  let tt; const toast = m => { const t = $('[data-nh-toast]'); t.textContent = m; t.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('is-on'), 2600); };

  /* modal helpers */
  let openModal = null;
  const open = el => { close(); openModal = el; el.classList.add('is-on'); document.documentElement.style.overflow = 'hidden'; };
  const close = () => { if (!openModal) return; openModal.classList.remove('is-on'); document.documentElement.style.overflow = ''; openModal = null; };
  root.addEventListener('click', e => { if (e.target.closest('[data-nh-close]') || e.target.classList.contains('nh-modal')) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });

  /* reviews slider */
  $$('[data-nh-rev]').forEach(b => b.addEventListener('click', () => { const t = $('.nh-track'); t.scrollBy({ left: t.clientWidth * +b.dataset.nhRev, behavior: 'smooth' }); }));

  /* standards steps */
  $$('.nh-step').forEach(s => s.addEventListener('click', () => $$('.nh-step').forEach(x => x.classList.toggle('is-on', x === s))));

  /* quick size picker */
  const products = {};
  $$('[data-nh-product]').forEach(s => { try { products[s.dataset.nhProduct] = JSON.parse(s.textContent); } catch (e) {} });
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  function quick(handle, color) {
    const p = products[handle]; if (!p) { location.href = '/products/' + handle; return; }
    const names = p.options.map(o => typeof o === 'string' ? o : o.name);
    const values = names.map((_, i) => [...new Set(p.variants.map(v => v.options[i]))]);
    const sel = names.map((n, i) => {
      const ln = n.toLowerCase();
      if ((ln === 'color' || ln === 'colour') && color && values[i].includes(color)) return color;
      if (ln.includes('pack')) return values[i].find(v => /single/i.test(v)) || values[i][0];
      if (ln === 'size' && values[i].length > 1) return null;
      return values[i][0];
    });
    const find = () => p.variants.find(v => v.options.every((o, i) => sel[i] === null || o === sel[i]) && sel.every(s => s !== null));
    const render = () => {
      const v = find();
      const colorIdx = names.findIndex(n => /^colou?r$/i.test(n));
      const key = colorIdx > -1 && sel[colorIdx] ? sel[colorIdx].replace(/ /g, '_') : null;
      const file = u => String(u).split('?')[0].split('/').pop();
      const byColor = key ? (p.images.find(u => file(u).includes(key) && file(u).includes('1Pack')) || p.images.find(u => file(u).includes(key))) : null;
      const img = (v && v.featured_image && v.featured_image.src) || byColor || p.featured_image;
      const price = v ? v.price : p.price_min;
      const cmp = v ? v.compare_at_price : null;
      $('[data-nh-qv]').innerHTML = `
        <div class="nh-qv__img">${img ? `<img src="${img}${img.includes('?') ? '&' : '?'}width=800" alt="${esc(p.title)}">` : ''}</div>
        <div class="nh-qv__det">
          <h3>${esc(p.title)}</h3>
          <div class="nh-price" style="font-size:18px;font-weight:700">${money(price)}${cmp && cmp > price ? `<s>${money(cmp)}</s>` : ''}</div>
          ${names.map((n, i) => values[i].length < 2 && n === 'Title' ? '' : `
            <div class="nh-opt">${esc(n)}${sel[i] ? ': ' + esc(sel[i]) : ''}</div>
            <div class="nh-chips">${values[i].map(val => {
              const any = p.variants.some(x => x.options[i] === val && x.available && x.options.every((o, j) => j === i || sel[j] === null || o === sel[j]));
              return `<button type="button" class="nh-chip${sel[i] === val ? ' is-on' : ''}" data-i="${i}" data-v="${esc(val)}" ${any ? '' : 'disabled'}>${esc(val)}</button>`;
            }).join('')}</div>`).join('')}
          <div class="nh-err" data-nh-err></div>
          <button type="button" class="nh-btn nh-btn--sky nh-btn--block" data-nh-add ${v && !v.available ? 'disabled' : ''}>${v && !v.available ? 'Sold out' : 'Add to cart'}</button>
          <a href="${p.url || '/products/' + p.handle}${v ? '?variant=' + v.id : ''}" style="font-size:12px;text-decoration:underline">View full details</a>
        </div>`;
      $$('[data-nh-qv] .nh-chip').forEach(c => c.addEventListener('click', () => { sel[+c.dataset.i] = c.dataset.v; render(); }));
      $('[data-nh-add]').addEventListener('click', async e => {
        const v = find();
        if (!v) { $('[data-nh-err]').textContent = 'Pick a ' + names[sel.findIndex(s => s === null)].toLowerCase() + ' first.'; return; }
        e.target.disabled = true; e.target.textContent = 'Adding…';
        try {
          const r = await fetch(cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
          if (!r.ok) throw new Error((await r.json()).description || 'Could not add to cart');
          location.href = cartUrl;
        } catch (err) { $('[data-nh-err]').textContent = err.message; e.target.disabled = false; e.target.textContent = 'Add to cart'; }
      });
    };
    $('[data-nh-qv]').style.gridTemplateColumns = 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))';
    render();
    open($('[data-nh-quick-modal]'));
  }
  root.addEventListener('click', e => { const q = e.target.closest('[data-nh-quick]'); if (q) { e.preventDefault(); quick(q.dataset.nhQuick, q.dataset.nhColor); } });

  /* scratch-to-reveal welcome popup */
  const promo = $('[data-nh-promo]');
  if (promo) {
    let seen = false; try { seen = sessionStorage.getItem('nh-promo') === '1'; } catch (e) {}
    let revealed = false;
    const show = () => { if (seen || openModal) return; seen = true; try { sessionStorage.setItem('nh-promo', '1'); } catch (e) {} open(promo); requestAnimationFrame(initScratch); };
    setTimeout(show, +root.dataset.promoDelay || 8000);
    const cv = $('canvas', promo);
    const reveal = () => { revealed = true; cv.style.transition = 'opacity .4s'; cv.style.opacity = 0; };
    function initScratch() {
      const r = cv.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
      cv.width = r.width * dpr; cv.height = r.height * dpr; const x = cv.getContext('2d'); x.scale(dpr, dpr);
      const g = x.createLinearGradient(0, 0, r.width, r.height); g.addColorStop(0, '#c5cad1'); g.addColorStop(.5, '#e8ebee'); g.addColorStop(1, '#b8bec6');
      x.fillStyle = g; x.fillRect(0, 0, r.width, r.height);
      x.strokeStyle = 'rgba(0,0,0,.08)'; for (let i = -r.height; i < r.width; i += 10) { x.beginPath(); x.moveTo(i, 0); x.lineTo(i + r.height, r.height); x.stroke(); }
      x.fillStyle = '#0c1a3a'; x.font = '700 16px sans-serif'; x.textAlign = 'center'; x.fillText('Scratch to reveal', r.width / 2, r.height / 2 + 5);
      x.globalCompositeOperation = 'destination-out';
      let down = false, n = 0;
      const scratch = e => { if (!down) return; const b = cv.getBoundingClientRect(); x.beginPath(); x.arc(e.clientX - b.left, e.clientY - b.top, 20, 0, Math.PI * 2); x.fill();
        if (!revealed && ++n % 8 === 0) { const d = x.getImageData(0, 0, cv.width, cv.height).data; let c = 0; for (let i = 3; i < d.length; i += 32) if (d[i] === 0) c++; if (c / (d.length / 32) > .45) reveal(); } };
      cv.onpointerdown = e => { down = true; cv.setPointerCapture(e.pointerId); scratch(e); };
      cv.onpointermove = scratch; cv.onpointerup = () => down = false;
    }
    $('[data-nh-claim]', promo).addEventListener('click', async () => {
      if (!revealed) { reveal(); return; }
      const code = root.dataset.promoCode;
      try { await navigator.clipboard.writeText(code); toast('Code ' + code + ' copied'); } catch (e) { toast('Your code is ' + code); }
      close();
      fetch('/discount/' + encodeURIComponent(code)).catch(() => {});
    });
  }
}
  const run = () => document.querySelectorAll('.nh[data-nh]').forEach(initNH);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();